"use client"
import "@/components/header/header.css"
import { EXPOSURE_RECORD, sendClickTrack } from "@/tracks/25061";

interface Props{
  name: string,
  link: string,
}

const NavItem = ({ name, link }: Props) => {

  return (
    <li
      className="nav-list-item"
      exptag={"exp|" + EXPOSURE_RECORD.Header_Navigation_Expo}
      data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
      data-exptag-json-param={JSON.stringify({ name: name })}
      onClick={() => {
        sendClickTrack.Header_Navigation({ name: name || "-100" });
      }}
    >
      <a href={link} target="_blank" rel="noopener noreferrer">
        {name}
      </a>
    </li>
  )
}

export default NavItem;